import { types } from 'actions/report'
import _ from 'underscore'

export default function reducer (state = [], action) {
  switch (action.type) {
    case types.LOAD_REPORT:
      return _.size(action.report.columns) ? action.report.columns : []
    case types.ADD_COLUMN:
      return [...state, action.attributes]
    case types.REMOVE_COLUMN:
      return state.filter((_, index) => index !== action.index)
    case types.UPDATE_COLUMN:
      return state.map((column, index) => 
        index === action.index ? { ...column, ...action.attributes } : column
      )
    case types.CHANGE_POSITION:
      const newState = [...state]
      const temp = newState[action.startIndex]
      newState[action.startIndex] = newState[action.endIndex]
      newState[action.endIndex] = temp
      return newState
  }
  return state
}
